import React from "react";
import { formatDate } from "../../utils";
import { t } from "i18next"; // Import t function for translation

const UserPointsHitsoryItem = (props) => {
  const { data } = props || {};

  let typeName;

  switch (data?.type) {
    case "SALE":
      typeName = t("userPointsHistory.saleType");
      break;
    case "EDUCATION":
      typeName = t("userPointsHistory.educationType");
      break;
    case "ADMINISTRATOR":
      typeName = t("userPointsHistory.adminType");
      break;
    default:
      typeName = t("userPointsHistory.saleType");
  }

  const today = new Date();
  const expireDate = new Date(data?.expireDate);
  const isExpired = expireDate < today;

  return (
    <div className="user-points-list-item">
      <div className="user-points-item-date d-flex justify-content-between align-items-center">
        <div className="user-points-item-date-item">
          {formatDate(data?.createdAt)}
        </div>
        <div className="user-points-item-date-item">
          {t("userPointsHistory.expireDate")}: {formatDate(data?.expireDate)}
          {isExpired && (
            <span className="expired-label">
              {" "}
              {t("userPointsHistory.expiredLabel")}
            </span>
          )}
        </div>
      </div>
      <div className="user-points-item-title d-flex justify-content-between align-items-center">
        <div className="user-points-item-title-item">{typeName}</div>
        <div className="user-points-item-title-item">
          {t("userPointsHistory.earnedPoints")}
        </div>
      </div>
      <div className="user-points-item-status d-flex justify-content-between align-items-center">
        <div className="user-points-item-status-item">
          <div className="user-points-item-status-item-points">
            {t("userPointsHistory.usedPoints")}: {data?.usedPoints}{" "}
            {t("userPointsHistory.points")}
          </div>
        </div>
        <div className="user-points-item-status-item">
          <div className="user-points-item-status-item-points">
            {data?.points} {t("userPointsHistory.points")}
          </div>
        </div>
      </div>
      <div className="user-points-item-status-item">
        <div className="user-points-item-status-item-points">
          {data?.employeeName} {data?.employeeLastName}
        </div>
      </div>
    </div>
  );
};

export default UserPointsHitsoryItem;
